import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-alert',
  templateUrl: './table-alert.component.html',
  styleUrls: ['./table-alert.component.scss'],
})
export class TableAlertComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
